import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { FileInfo } from "./fileSlice";
import { getToken } from "../../features/user/UserAvatar";

export interface FileInsState {
  state: LoadStateInfo;
  file: FileInfo;
}

const initialState: FileInsState = {
  state: notStarted(),
  file: emptyFile(),
};

function emptyFile(): FileInfo {
  return {
    id: "",
    schoolId: "",
    createdAt: "",
    fileStatus: 0,
  };
}

export interface FileInsTargetRequest {
  schoolId: string;
  conversationId: string;
  partyId: string;
}

export interface FileInsRequest {
  file: File;
  target: FileInsTargetRequest;
}

export const fileInsert = createAsyncThunk(
  "fileInsert",
  async (param: FileInsRequest, thunkAPI) => {
    console.debug("insert file");

    let queryParams = `filename=${param.file.name}`;
    queryParams += `&schoolId=${param.target.schoolId}`;
    queryParams += `&conversationId=${param.target.conversationId}`;
    queryParams += `&partyId=${param.target.partyId}`;
    const response = await fetch(`${getBackendUrl()}/api/file?${queryParams}`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": `${param.file.type}`,
      },
      body: param.file
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const fileInsSlice = createSlice({
  name: "fileInsSlice",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    set: (state, action: PayloadAction<FileInfo>) => {
      state.state = notStarted();
      state.file = action.payload;
    },
    clean: (state) => {
      state.state = notStarted();
      state.file = emptyFile();
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(fileInsert.pending, (state/* , action */) => {
        state.state =  loading();
      })
      .addCase(fileInsert.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.file = action.payload;
      })
      .addCase(fileInsert.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

export const selectFileIns = (state: RootState) => state.fileIns;

export default fileInsSlice.reducer;
